var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"account-form-layout",on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_vm._t("default"),_c('div',{staticClass:"account-form-layout__footer"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }